import { Heading } from "@chakra-ui/react";

export default function Home() {
    return (
        <Heading size="lg" textAlign="center" mt={8} color="default-text">
            Eyebright Office Portal
        </Heading>
    )
}